module.exports = __webpack_public_path__ + "static/media/esther.06e200bf.jpeg";